import React from "react";
import marked from "marked";
import dompurify from "dompurify";
import ProductFeatureVideo from "./ProductFeatureVideo";
import ProductFeatureImage from "./ProductFeatureImage";

interface ProductFeatureProps {
    imageLocation:string; //Would be equivalent to ImageLocation on the DynoFeaturemodel
    id:number;
    title?:string;
    imagePath:string;
    videoPath:string;
    videoThumbImage:string;
    isVideo:boolean;
    guid:string;
    textContent?:string;
    footerNotes:string;
    localisedProductName:string;
}

const ProductFeature = (props:ProductFeatureProps) => {

    const [imageOnlyFeature, setImageOnlyFeature] = React.useState<boolean>(false);
    const [description, setDescription] = React.useState<string>("");
    const [styleClass, setStyleClass] = React.useState<string>("none");
    
    React.useEffect(() => {
        if(props.textContent == undefined || props.textContent == "") {
            setImageOnlyFeature(true);
        }
        else {
            setDescription(dompurify.sanitize(marked.parse(props.textContent.replace("{{ProductName}}", props.localisedProductName))));
        }

        configureStyle();
    }, []);

    const configureStyle = () => {
        switch(props.imageLocation.toUpperCase()) {
            case "NONE":
                setStyleClass("none");
                break;
            case "LEFT":
                setStyleClass("leftaligned");
                break;
            case "RIGHT":
                setStyleClass("rightaligned");
                break;
            case "BELOW":
                setStyleClass("imagebelow");
                break;
        }
    }
    
    const populateFeatureMedia = () => {
        return (
            (
                props.isVideo ? <ProductFeatureVideo videoThumb={props.videoThumbImage} videoPath={props.videoPath} /> 
                    : (props.imagePath != null && props.imagePath != "") &&
                    <ProductFeatureImage imageLocation={props.imageLocation} imagePath={props.imagePath} altText={props.title} />
            )
        )
    }

    if(imageOnlyFeature) {
        return (
            <div className="product-feature centredimage">
                {/*Refer to ConvergeFeatures.ascx BuildFeatureImage for code to replicate here*/}
                {populateFeatureMedia()}
            </div>
        )
    }
    
    switch(props.imageLocation.toUpperCase()) {
        case "NONE":
            return (
                <div className="product-feature imagebelow">
                    <div className="centredtext markdownStyles">
                        <h3>{props.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: description}}></div>
                    </div>
                </div>
            )
        case "LEFT":
            return (
                <div className="product-feature leftaligned">
                    <div className="floatcontainer">
                        <div className="smallfloat">
                            {/*Refer to ConvergeFeatures.ascx BuildFeatureImage for code to replicate here*/}
                            {populateFeatureMedia()}
                        </div>
                        <div className="largefloat markdownStyles">
                            <h3>{props.title}</h3>
                            <div dangerouslySetInnerHTML={{__html: description}}></div>
                        </div>
                    </div>
                </div>
            )
        case "RIGHT":
            return (
                <div className="product-feature rightaligned">
                    <div className="floatcontainer">
                        <div className="largefloat markdownStyles">
                            <h3>{props.title}</h3>
                            <div dangerouslySetInnerHTML={{__html: description}}></div>
                        </div>
                        <div className="smallfloat">
                            {/*Refer to ConvergeFeatures.ascx BuildFeatureImage for code to replicate here*/}
                            {populateFeatureMedia()}
                        </div>

                    </div>
                </div>
            )
        case "BELOW":
            return (
                <div className="product-feature imagebelow">
                    <div className="centredtext markdownStyles">
                        <h3>{props.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: description}}></div>
                    </div>

                    <div className="centredimage">
                        {/*Refer to ConvergeFeatures.ascx BuildFeatureImage for code to replicate here*/}
                        {populateFeatureMedia()}
                    </div>
                    
 
                </div>
            )
    }

    return (
        <div className={`product-feature ${styleClass}`}>
            <div dangerouslySetInnerHTML={{__html: description}}></div>
        </div>
    )
}

export default ProductFeature;